import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'LuxKit/Typography/Heading'
import React from 'react'
import Sheet from 'components/utils/Sheet'
import Faq from 'components/Common/Faq'
import { FormattedMessage } from 'react-intl'

interface Props {
  slug: string
}

function TripLandingFaq(props: Props) {
  const { slug } = props
  return <Sheet padding="48 0" tabletPadding="64 0">
    <LayoutContainer variant="medium">
      <VerticalSpacer gap={24}>
        <Heading variant="heading3">
          <FormattedMessage
            id="gcWJRgPrzZ"
            defaultMessage="Any <i>questions?</i> We've got answers"
            description="Heading for frequently asked questions section"
            values={{
              i: (chunks: React.ReactNode) => <i key="italic">{chunks}</i>,
            }}
          />
        </Heading>
        <Faq
          slug={slug}
        />
      </VerticalSpacer>
    </LayoutContainer>
  </Sheet>
}

export default TripLandingFaq
